
/**
 * @file dcp/src/dcp-client/worker/supervisor2/promise_any.js
 *
 * A support class for Supervisor2.
 * Polyfill for Promise.any
 * Promise.any is supported in Node 15, Chrome 85, Edge 85, Firefox 79, Safari 14, Opera 71.
 * It was implemented in node and browsers in 2nd half of 2020.
 *
 * @author Paul, paul@distributive.network
 * @date Feb 2023,
 * @module promise_any
 * @copyright Copyright (c) 2018-2025, Distributive Corp. All Rights Reserved
 */

/**
 * Polyfill for Promise.any
 * @param {Promise[]} promiseArray
 * @returns {Promise}
 */
exports.Promise_any = function polyfill$$Promise_any(promiseArray)
{
  if (typeof Promise.any === 'function')
    return Promise.any(promiseArray);
  return new Promise((resolve, reject) => {
    const promiseErrors = new Array(promiseArray.length);
    let counter = 0;
    for (let index = 0; index < promiseArray.length; index++)
    {
      Promise.resolve(promiseArray[index])
        .then(resolve) // Resolve when any of the input promise resolves.
        .catch((error) => {
          promiseErrors[index] = error;
          counter = counter + 1;
          if (counter === promiseArray.length) // All promises rejected, reject outer promise.
            reject(promiseErrors);
        });
    }
  });
}
